import { Directive, ElementRef, inject } from '@angular/core';

import { MobileFlyoutMenuNavComponent } from './mobile-flyout-menu-nav.component';

// Define a minimal HammerInput interface if not already imported
interface PanEvent {
  deltaX: number;
  // ...other properties if needed
}

@Directive({
  selector: '[tdWbMobileFlyoutMenuNavPan]',
  exportAs: 'tdWbMobileFlyoutMenuNavPan',
  host: {
    '(swiperight)': 'swipeRight()',
    '(panstart)': 'panStart()',
    '(panleft)': 'panMove($event)',
    '(panright)': 'panMove($event)',
    '(panend)': 'panEnd($event)'
  }
})
export class MobileFlyoutMenuNavPanDirective {
  private readonly elementRef = inject(ElementRef);
  private readonly navComponent = inject(MobileFlyoutMenuNavComponent, { host: true });

  static readonly PANEL_WIDTH: number = 300;
  static readonly HALF_PANEL_WIDTH: number = 300 / 2;

  private translateOffset: number = 0;

  swipeRight(): void {
    if (!this.navComponent.opened()) {
      this.navComponent.open();
    }
  }

  panStart(): void {
    const rect = this.elementRef.nativeElement.getBoundingClientRect();
    this.translateOffset = rect.left;
    this.navComponent.stopAnimation();
    this.navComponent.open();
  }

  panMove(event: Event): void {
    const panEvent = event as unknown as PanEvent;
    const deltaX = (panEvent && typeof panEvent.deltaX === 'number') ? panEvent.deltaX : 0;
    this.draw(deltaX + this.translateOffset);
  }

  panEnd(event: Event): void {
    const panEvent = event as unknown as PanEvent;
    const deltaX = (panEvent && typeof panEvent.deltaX === 'number') ? panEvent.deltaX : 0;
    const x = deltaX + this.translateOffset;

    if (x  < -1 * MobileFlyoutMenuNavPanDirective.HALF_PANEL_WIDTH) {
      this.navComponent.close();
    } else {
      this.navComponent.moveTo(0);
      this.navComponent.open();
    }
    this.navComponent.startAnimation();
  }

  private draw(x: number): void {
    const left = Math.max(-1 * MobileFlyoutMenuNavPanDirective.PANEL_WIDTH, Math.min(x, 0));
    this.navComponent.moveTo(left);
  }
}
